export default "__VITE_ASSET__C_JEaX2Q__"